import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";

class NotificationItem extends Component {
  constructor(props) {
    super(props);
    this.touchableInactive = false;
  }

  handleClick(formId, id, e) {
    if (!this.touchableInactive) {
      this.touchableInactive = true;
      setTimeout(() => {
        this.touchableInactive = false;
      }, 1500);

      this.props.onClick(
        formId,
        id,
        this.props.notification.dateOpen === null ? false : true
      );
    }
  }

  format(dt) {
    if (dt.toString().length === 1) {
      return "0" + dt;
    }

    return dt;
  }

  render() {
    let thisNotification = this.props.notification.data;
    let dateAddedT = new Date(this.props.notification.dateAdded);
    let dateAdded =
      dateAddedT.getDate() +
      "/" +
      dateAddedT.getMonth() +
      "/" +
      dateAddedT.getFullYear() +
      " " +
      this.format(dateAddedT.getHours()) +
      ":" +
      this.format(dateAddedT.getMinutes());

    return (
      <div
        className="listcontainer"
        style={{
          flex: 1,
          width: "330px",
          borderRadius: 4,
          marginBottom: 30,
          backgroundColor: "white",
          borderWidth: 2,
          flexDirection: "row"
        }}
      >
        <div
          onClick={this.handleClick.bind(
            this,
            thisNotification.formId,
            this.props.notification.id
          )}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
            width: "100%",
            cursor: "pointer",
            alignItems: "center"
          }}
        >
          <div style={{ flexDirection: "row" }}>
            <div style={{ paddingBottom: 0, flex: 1, paddingLeft: 0 }}>
              <div
                style={{ flex: 1, position: "relative", flexDirection: "row" }}
              >
                <div
                  style={{
                    marginLeft: 10,
                    marginRight: 40,
                    flexDirection: "column"
                  }}
                >
                  <div style={{ flexDirection: "row" }}>
                    <span
                      style={{
                        fontSize: 16,
                        paddingLeft: 20,
                        fontWeight:
                          this.props.notification.dateOpen === null
                            ? "bold"
                            : "normal",
                        textAlignVertical: "center",
                        padding: 2
                      }}
                    >
                      {thisNotification.title}
                    </span>
                  </div>
                  <div style={{ flexDirection: "row" }}>
                    <span
                      style={{
                        fontSize: 14,
                        paddingLeft: 20,
                        textAlignVertical: "center",
                        padding: 2,
                        color: "grey"
                      }}
                    >
                      {thisNotification.message}
                    </span>
                  </div>
                  <div style={{ flexDirection: "row" }}>
                    <span
                      style={{
                        fontSize: 11,
                        paddingLeft: 20,
                        textAlignVertical: "center",
                        padding: 2,
                        color: "silver"
                      }}
                    >
                      {dateAdded}
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    float: "right",
                    position: "absolute",
                    top: 17,
                    right: 20,
                    justifyContent: "center"
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      class="ffff"
                      d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                    />
                    <path fill="none" d="M0 0h24v24H0V0z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NotificationItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  notification: PropTypes.object.isRequired
};

export default NotificationItem;



// WEBPACK FOOTER //
// ./src/components/NotificationItem/index.js